// src/constants/subjects.js
export const SUBJECT_GROUPS = [
  {
    title: 'First Professional',
    key: 'prof1',
    subjects: [
      { name: 'Anatomy', slug: 'anatomy', allowsIntern: false },
      { name: 'Biochemistry', slug: 'biochemistry', allowsIntern: false },
      { name: 'Physiology', slug: 'physiology', allowsIntern: false },
    ],
  },
  {
    title: 'Second Professional',
    key: 'prof2',
    subjects: [
      { name: 'Pathology', slug: 'pathology', allowsIntern: false },
      { name: 'Microbiology', slug: 'microbiology', allowsIntern: false },
      { name: 'Pharmacology', slug: 'pharmacology', allowsIntern: false },
      { name: 'Forensic Medicine and Toxicology', slug: 'forensic-medicine-and-toxicology', allowsIntern: true },
    ],
  },
  {
    title: 'Third Professional Part 1',
    key: 'prof3p1',
    subjects: [
      { name: 'Ophthalmology', slug: 'ophthalmology', allowsIntern: true },
      { name: 'Otorhinolaryngology', slug: 'otorhinolaryngology', allowsIntern: true },
      { name: 'Community Medicine', slug: 'community-medicine', allowsIntern: true },
    ],
  },
  {
    title: 'Third Professional Part 2',
    key: 'prof3p2',
    subjects: [
      { name: 'Medicine', slug: 'medicine', allowsIntern: true },
      { name: 'Surgery', slug: 'surgery', allowsIntern: true },
      { name: 'Pediatrics', slug: 'pediatrics', allowsIntern: true },
      { name: 'Obstetrics and Gynaecology', slug: 'obstetrics-and-gynaecology', allowsIntern: true },
      { name: 'Psychiatry', slug: 'psychiatry', allowsIntern: true },
      { name: 'Anesthesia', slug: 'anesthesia', allowsIntern: true },
      { name: 'Radiology', slug: 'radiology', allowsIntern: true },
      { name: 'Dermatology', slug: 'dermatology', allowsIntern: true },
    ],
  },
];

export function findSubjectBySlug(slug) {
  for (const group of SUBJECT_GROUPS) {
    const s = group.subjects.find(x => x.slug === slug);
    if (s) return { ...s, group };
  }
  return null;
}
